import { useMutation } from '@tanstack/react-query';
import type { AxiosError, AxiosResponse } from 'axios';
import { tasksApi, type TaskSnapshot } from '../../../api';
import { useAuthenticatedRequest } from '../../../config/auth-config';
import { queryClient } from '../../../config/react-query';
import { useNotifications } from '../../../utils/notifications';

export const useCancelTaskMutation = () => {
  const authRequest = useAuthenticatedRequest();
  const { notifyError } = useNotifications();

  return useMutation<AxiosResponse<TaskSnapshot>, AxiosError, string>({
    mutationFn: (taskId: string) => authRequest(config => tasksApi.cancelTask(taskId, config)),
    onSuccess: response => {
      const snapshot = response.data;
      queryClient().setQueryData(['task', snapshot.id], snapshot);
      queryClient().invalidateQueries({ queryKey: ['tasks'] });
    },
    onError: error => {
      notifyError({
        title: 'Cancel Task Failed',
        description: error.message ?? 'Unable to cancel the task',
      });
    },
  });
};
